export const supportOldEpaWorkloads = (defaultWl, oldWorkload) => {

  
    if(Array.isArray(oldWorkload.UserInputs.Environments.Environment)){
        if(oldWorkload.UserInputs.Environments.isOldWorkload){
            oldWorkload.UserInputs.Environments.isOldWorkload=false;
        }
        return oldWorkload;
    }
   

    let clonedoldWl = JSON.parse(JSON.stringify(oldWorkload));
    let clonedDefaultWl = JSON.parse(JSON.stringify(defaultWl));
    const gandcRoles = ['Gateway Host', 'Controller Host'];
    const GeneralPurpose = "General Purpose";
    const roleName="@RoleName";
    const solutionType="@SolutionType";
    const KUBERNETES_ = "Kubernetes";
    const COST_ = "Cost";
    const STORAGE_ = "Storage";
    const ATTRIBUTE_CONFIGTYPE = "@ConfigType";
    const EPIC_ = "EPIC";
    //get GPU item
    //update templates
    let roles;
    let generalPurposeObj = clonedDefaultWl.UserInputs.Environments.Environment.find(item => item[solutionType] === GeneralPurpose);
    if (generalPurposeObj) {
        clonedoldWl.UserInputs.Environments.Templates.Template.map(template=> {
            if (!template["@ConfigType"]) {
                template["@ConfigType"] = KUBERNETES_;
            }
        })
        if (!clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Requirements["@ConfigBasedOn"]) {
            clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Requirements["@ConfigBasedOn"] = COST_
        }
        if (!clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Requirements[ATTRIBUTE_CONFIGTYPE]) {
            clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Requirements[ATTRIBUTE_CONFIGTYPE] = EPIC_;
        }
        const defaultStorageRole = generalPurposeObj.Templates.ServerDetails.Server.find(role => role["@Type"] === STORAGE_);
        generalPurposeObj.Templates = clonedoldWl.UserInputs.Environments.Templates;
        roles =  JSON.parse(JSON.stringify(clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Server));
        generalPurposeObj.Templates.ServerDetails.Server = roles.filter(item => gandcRoles.indexOf(item[roleName]) === -1);
        if (!generalPurposeObj.Templates.ServerDetails.Server.find(role => role["@Type"] === STORAGE_)) {
            generalPurposeObj.Templates.ServerDetails.Server.push(defaultStorageRole);
        }
        generalPurposeObj.GPUValue = clonedoldWl.UserInputs.Environments.GPUValue;
        generalPurposeObj.NonGPUValue = clonedoldWl.UserInputs.Environments.NonGPUValue;
        generalPurposeObj.StorageValue = clonedoldWl.UserInputs.Environments.StorageValue;
    }
    //update management hosts
    if (roles) {
        clonedDefaultWl.UserInputs.Environments.ManagementHosts.Server = roles.filter(item => gandcRoles.indexOf(item[roleName]) !== -1);
        updateVMWareOption(clonedDefaultWl.UserInputs.Environments.ManagementHosts.Server);
    }
    clonedDefaultWl.UserInputs.Environments.isOldWorkload = true;

    return clonedDefaultWl;
}

export const updateVMWareOption = (managementRoles) => {
    const fALSE_ = "false";    
    managementRoles.map(role => {
        if (!role["@VMWare"]) {
            role["@VMWare"] = fALSE_
        }
    })
}



// WEBPACK FOOTER //
// ./src/State/reducers/commonLogic.js